import axios from "./config";
import { API } from "./api";

export const searchProductsService = async (body) => {
  return axios
    .post(API.searchProducts, body)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getProductCategoryService = async (category) => {
  return axios
    .get(`${API.siteRepo.root}${API.siteRepo.getProductCategory.replace("{0}", category)}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const isSchedulingFetch = async (body) => {
  return axios
    .get(API.isSchedulingToggle.replace("{0}", body))
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
